import * as React from "react";
import { Anchor } from "../typography/anchor/anchor.mjs";
import { List } from "../list/list/list.mjs";
import { ListItem } from "../list/list-item/list-item.mjs";
const Languages = (props) => {
  const { theme, className, languages } = props;
  const renderLanguage = React.useCallback(
    ({ label, ...rest }, index) => /* @__PURE__ */ React.createElement(ListItem, { key: index, className: "text-small" }, /* @__PURE__ */ React.createElement(Anchor, { ...rest, theme, isTextColor: true, isUnderlined: false, className: "text-weight-normal" }, label)),
    [theme]
  );
  return /* @__PURE__ */ React.createElement(List, { type: "unstyled", direction: "inline", bordered: true, className, theme }, languages.map(renderLanguage));
};
export {
  Languages
};
